import { PageErrorBoundary } from '@/components/PageErrorBoundary'
import { CrmPage } from './CrmPage'
import { useCrmAccess } from './useCrmAccess'

/**
 * `/crm`, for super admins and care coordinators. Renders nothing until the role is known, and
 * says so rather than redirecting when access is off — as PopulationRoute does.
 */
export function CrmRoute() {
  const access = useCrmAccess()
  if (access === undefined) return null
  if (!access) {
    return (
      <div className="p-6">
        <h1 className="text-2xl font-semibold">CRM</h1>
        <p className="mt-2 text-sm text-gray-600">The CRM isn’t enabled for your account.</p>
      </div>
    )
  }
  return (
    <PageErrorBoundary feature="crm">
      <CrmPage />
    </PageErrorBoundary>
  )
}
